import { render, staticRenderFns } from "./OrdersIResaList.vue?vue&type=template&id=05d44695"
import script from "./OrdersIResaList.vue?vue&type=script&lang=js"
export * from "./OrdersIResaList.vue?vue&type=script&lang=js"
import style0 from "./OrdersIResaList.vue?vue&type=style&index=0&id=05d44695&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports